import { createFileRoute } from '@tanstack/react-router';
import { LegalDoc } from '../components/legal/LegalDoc';
import content from '../content/legal/terms-of-service.md?raw';

export const Route = createFileRoute('/terms')({
  component: () => <LegalDoc content={content} />,
});
